import { render, staticRenderFns } from "./PrijavaForma.vue?vue&type=template&id=68570464&scoped=true&"
import script from "./PrijavaForma.vue?vue&type=script&lang=js&"
export * from "./PrijavaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68570464",
  null
  
)

export default component.exports